import { round } from "lodash";
import { Price } from "../store/services/invitations/dto/invitations.dto";
import { formatCurrency } from "./formatCurrency";

export const getInvitationPrice = (price: number, is_discount_percentage: boolean, discount: number) => {
	return round(price - (is_discount_percentage ? price * (discount / 100) : discount), 2);
};

export const getStartPrice = (
	pricing: Price[] = []
): { amount: number; currency: string; discount: number; is_discount_percentage: boolean } => {
	if (pricing.length === 0) return { amount: 0, currency: "EGP", discount: 0, is_discount_percentage: false };
	return {
		amount: pricing[0].amount,
		currency: pricing[0].currency,
		discount: pricing[0].discount,
		is_discount_percentage: pricing[0].is_discount_percentage
	};
};

export const getDiscountAmount = (discount: number, currency: string, is_discount_percentage: boolean) => {
	return is_discount_percentage ? `${discount}%` : `${formatCurrency(discount, currency)}`;
};
